<div id="showcase">

  <!-- ── CAROUSEL (COMMENTED OUT) ─────────────────────────── -->
  <!--
  <div id="showcaseCarousel" class="carousel slide" data-bs-ride="carousel">
    <div class="carousel-indicators">
      <button type="button" data-bs-target="#showcaseCarousel" *ngFor="let slide of slider, let i = index"
        class="{{ (i == 0) ? 'active' : '' }}" attr.data-bs-slide-to="{{i}}" aria-current="true"
        [attr.aria-label]="'Slide ' + (i+1)">
      </button>
    </div>

    <div class="carousel-inner">
      <div class="carousel-item" *ngFor="let slide of slider, let i=index" [ngClass]="(i == 0) ? 'active' : ''">
        <div class="container-fluid d-flex justify-content-center align-items-center" id="loader" *ngIf="isLoading[i]">
        </div>
        <img [src]="slide.imgUrl" alt="Slider" class="img-fluid w-100 animate__animated animate__slideInRight"
          [ngStyle]="{visibility: isLoading[i] ? 'hidden' : 'visible'}" (load)="hideLoader(i)" (error)="hideLoader(i)">

        <div class="slide-gradient-panel"></div>

        <div class="slide-content" *ngIf="!isLoading[i]">
          <div class="slide-badge">
            <i class="fa fa-award"></i>&nbsp; NAAC Accredited &nbsp;|&nbsp; Est. 1997
          </div>
          <h1 class="slide-heading">
            Empowering Women<br>
            <span class="slide-heading-accent">Through Excellence</span><br>
            in Education
          </h1>
          <p class="slide-desc">
            Shah Satnam Ji Girls' College, Sirsa — a premier institution dedicated to
            the holistic development of women through academic excellence, spiritual
            values, and community leadership.
          </p>
          <div class="slide-actions">
            <a routerLink="/admissions/registration" class="slide-btn-primary">
              <i class="fa fa-pen-to-square"></i> Apply Now 2026–27
            </a>
            <a routerLink="/hei/about-ssgc" class="slide-btn-outline">
              <i class="fa fa-circle-play"></i> Explore More
            </a>
          </div>
          <div class="slide-courses">
            <span>B.A.</span><span>B.Sc.</span><span>B.Com</span><span>M.A.</span><span>BCA</span>
          </div>
        </div>
      </div>
    </div>

    <button class="carousel-control-prev" type="button" data-bs-target="#showcaseCarousel" data-bs-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Previous</span>
    </button>
    <button class="carousel-control-next" type="button" data-bs-target="#showcaseCarousel" data-bs-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Next</span>
    </button>
  </div>
  -->

  <!-- ── BACKGROUND VIDEO SHOWCASE ────────────────────────── -->
  <div class="video-container">
    <video autoplay [muted]="isMuted" loop playsinline class="bg-video" #bgVideo>
      <source src="/assets/mp4/SSJGC-For-WEB-Final-16-july-ENGLISH.mp4" type="video/mp4">
    </video>
    <!-- <div class="video-overlay"></div> -->
    <div class="video-content">
      <div class="title-badge animate__animated animate__fadeInDown">ESTD. 1997</div>
      <h1 class="college-title animate__animated animate__fadeInUp fw-bold">Shah Satnam Ji Girls' College, Sirsa</h1>
    </div>

    <!-- Video Controls Overlay -->
    <div class="video-controls">
      <button class="vid-ctrl-btn" (click)="togglePlay(bgVideo)" [title]="isPlaying ? 'Pause' : 'Play'">
        <i class="fa-solid" [ngClass]="isPlaying ? 'fa-pause' : 'fa-play'"></i>
      </button>
      <button class="vid-ctrl-btn" (click)="toggleMute(bgVideo)" [title]="isMuted ? 'Unmute (Sound On)' : 'Mute (Sound Off)'">
        <i class="fa-solid" [ngClass]="isMuted ? 'fa-volume-xmark' : 'fa-volume-high'"></i>
      </button>
    </div>
  </div>



  <!-- ── POLICY LINKS BAR ──────────────────────────────────── -->
  <div class="policy-bar">
    <div class="policy-links">
      <a routerLink="/public-self-disclosure">Public Self Disclosure</a>
      <span class="sep">|</span>
      <a href="/assets/img/cbse/Anti Ragging.jpeg" target="_blank">Anti Ragging</a>
      <span class="sep">|</span>
      <a href="/assets/pdf/home/Sexual Harassment Committee.pdf" target="_blank">Sexual Harassment</a>
      <span class="sep">|</span>
      <a href="/assets/img/cbse/Internal Complain Committee.jpeg" target="_blank">Internal Complain</a>
      <span class="sep">|</span>
      <a href="/assets/img/cbse/Grievance.jpeg" target="_blank">Student Grievances</a>
      <span class="sep">|</span>
      <a href="/assets/pdf/home/Information-of-RTI-2.pdf" target="_blank">RTI</a>
      <span class="sep">|</span>
      <a href="/assets/img/cbse/Statutory Cell.jpeg" target="_blank">Statutory Cell</a>
    </div>
  </div>

  <!-- ── QUICK NAV BAR ─────────────────────────────────────── -->
  <div class="showcase-quicknav">
    <a routerLink="/admissions/registration" class="qnav-item">
      <i class="fa-solid fa-rocket"></i>
      <span>Start Your Journey with Us</span>
    </a>
    <a routerLink="/academics/programs" class="qnav-item">
      <i class="fa-solid fa-graduation-cap"></i>
      <span>Programs</span>
    </a>
    <a routerLink="/alumni/association" class="qnav-item">
      <i class="fa-solid fa-users"></i>
      <span>Alumni</span>
    </a>
    <a routerLink="/info/recent-events" class="qnav-item">
      <i class="fa-solid fa-calendar-days"></i>
      <span>News and Events</span>
    </a>
    <a routerLink="/visit/infrastructure" class="qnav-item">
      <i class="fa-solid fa-camera"></i>
      <span>Virtual Tour</span>
    </a>
  </div>

</div>